import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => ({
  pageTitle: {
    fontSize: 26,
    fontWeight: 300
  },
  pageContentDIv: {
    //marginTop:30,
    padding: 0,
    height: 'calc(100vh - 255px)',
    overflow: 'auto',
    overflowX:'hidden'
  },
  paper:{
    padding:'16px 24px',
    boxShadow:'2px 2px 4px 0 rgb(0 0 0 / 15%)'
  },
  gstAdd:{
    fontSize:20,
    fontWeight:600
  },
  gstSecondary:{
    fontSize:14,
    color:'#656565'
  },
  forwardIcon:{
    color:"#656565"
  },
  settings:{
    color:'#6b778c',
    fontWeight:600
  },
  reminderInput:{
   width:'100%',
   display:'flex',
   alignItems:'center'
  },
  reminderselect:{
    '& .MuiSelect-select':{
       paddingTop:2,
       paddingBottom:2
    }
  },
  selectDiv:{
   marginLeft:6,
   marginRight:6
  },
  reminderIcon:{
    color:'#0033cc',
    marginTop:-3,
    fontSize:20
  }
}));
export default useStyles;